import { Table } from '@/components';
import { loadingTableHandler } from '@/utils/handler/loadingTableHandler';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';
import { ICurrency } from '../types';

interface CurrencyExchangeTableProps {
  isLoading: boolean;
  currencies: ICurrency[];
  canManage: boolean;
  onEdit: (record: ICurrency) => void;
  onDelete: (record: ICurrency) => void;
}

export const CurrencyExchangeTable: React.FC<CurrencyExchangeTableProps> = ({
  isLoading,
  currencies,
  canManage,
  onEdit,
  onDelete,
}) => {
  const columns: ColumnsType<ICurrency> = [
    {
      title: 'Currency Name',
      dataIndex: 'dogma_name',
      key: 'dogma_name',
    },
    {
      title: 'ISO Code',
      dataIndex: 'dogma_isocurrencycode',
      key: 'dogma_isocurrencycode',
      render: (value: string) => <Tag color="blue">{value}</Tag>,
    },
    {
      title: 'Exchange Rate',
      dataIndex: 'dogma_exchangerate',
      key: 'dogma_exchangerate',
      render: (value: number, record: ICurrency) => (
        <div>
          <span className="font-bold">{value ?? '-'}</span>
          {value && record.dogma_isocurrencycode && (
            <div className="text-xs text-gray-400 mt-0.5">
              1 GBP = {value} {record.dogma_isocurrencycode}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'VAT (%)',
      dataIndex: 'dogma_vatpercentage',
      key: 'dogma_vatpercentage',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 80,
      render: (_: unknown, record: ICurrency) => {
        const menuItems = [
          {
            key: 'edit',
            label: 'Edit',
            onClick: () => onEdit(record),
          },
          ...(canManage
            ? [
                {
                  key: 'delete',
                  label: <span className="text-red-500">Delete</span>,
                  onClick: () => onDelete(record),
                },
              ]
            : []),
        ];

        return (
          <Dropdown rootClassName="row_actions_dropdown" menu={{ items: menuItems }}>
            <MoreOutlined />
          </Dropdown>
        );
      },
    },
  ];

  return loadingTableHandler(
    isLoading,
    <Table<ICurrency>
      columns={columns}
      dataSource={currencies}
      rowKey="dogma_currencyid"
      isLoading={isLoading}
    />
  );
};
